
import { useNavigate } from 'react-router-dom';

interface ActivationCallToActionProps {
  nextPendingHref: string | null;
  nextPendingTitle: string | null;
}

/**
 * Banner inline compacto que indica el siguiente paso pendiente. Antes era una
 * card vertical de ~250px que duplicaba lo que el progress bar (X/Y) y el
 * subtitle ya comunican, robándole foco visual a la grid de step cards (donde
 * están las acciones reales). Ahora es una sola línea con el nombre del próximo
 * step y un atajo para continuar.
 *
 * Cuando todo está completo el padre no renderiza este componente — no hace
 * falta una rama para "all completed".
 */
export default function ActivationCallToAction({
  nextPendingHref,
  nextPendingTitle,
}: ActivationCallToActionProps) {
  const navigate = useNavigate();

  const handleContinue = () => {
    if (nextPendingHref) navigate(nextPendingHref);
  };

  return (
    <div className="bg-blue-50 dark:bg-blue-900/10 rounded-lg border border-blue-100 dark:border-blue-900/30 px-4 py-3 flex items-center gap-3">
      <span className="material-symbols-outlined text-primary text-2xl shrink-0">play_circle</span>
      <div className="flex-1 min-w-0">
        <p className="text-[10px] font-semibold uppercase tracking-wider text-primary">Siguiente paso</p>
        <p className="text-sm font-semibold text-slate-900 dark:text-white truncate">{nextPendingTitle ?? '—'}</p>
      </div>
      <button
        type="button"
        onClick={handleContinue}
        disabled={!nextPendingHref}
        className="shrink-0 bg-primary hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed text-white text-xs font-bold px-3 py-2 rounded-md inline-flex items-center gap-1.5 shadow-sm shadow-primary/20 transition-colors"
      >
        Continuar
        <span className="material-symbols-outlined text-base">arrow_forward</span>
      </button>
    </div>
  );
}
